import { RichTextBox } from '@/components/RichTextBox';
import { LabradorComponent } from '@/types/component';

export const LabradorRichTextBox: LabradorComponent = ({ type, data, meta, descendants, ...props }) => {
  return <RichTextBox markup={data.content} data-content-index={meta.contentIndex} {...props} />;
};
